import axios from "axios";
import { store } from "../store";
import { clearSession } from "../store/slices/auth/auth.slice";
import { normalizeApiError } from "../utils/normalizeApiError";

const baseURL = process.env.REACT_APP_API_BASE_URL;

if (!baseURL) {
  throw new Error("REACT_APP_API_BASE_URL is not defined");
}

const axiosInstance = axios.create({
  baseURL,
 
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});

const PUBLIC_ROUTES = [
  "/sign-up-or-login/google",
  "/sign-up",
  "/login",
  "/auth/login/native",
];


axiosInstance.interceptors.request.use((config) => {
  const isPublicRoute = PUBLIC_ROUTES.some(
    (route) => config.url?.startsWith(route)
  );

  if (isPublicRoute) {
    
    delete config.headers.Authorization;
    return config;
  }
 

  // reading authToken for protected routes
  const stateToken = store.getState().auth.accessToken;
   const storageToken = localStorage.getItem("persist:auth")
    ? JSON.parse(localStorage.getItem("persist:auth")!).accessToken
    : null;

  const token = stateToken || storageToken;
 

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});




let isRefreshing = false;

let pendingRequests: {
  resolve: (value?: unknown) => void;
  reject: (reason?: any) => void;
}[] = [];


const processQueue = (error?: any) => {
  pendingRequests.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve();
    }
  });
  pendingRequests = [];
};


axiosInstance.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest?._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          pendingRequests.push({ resolve, reject });
        }).then(() => axiosInstance(originalRequest));
      }

      isRefreshing = true;

      // 🔐 No refresh logic yet — logout immediately on 401
      store.dispatch(clearSession());
      const currentUrl = window.location.pathname + window.location.search + window.location.hash;
      window.location.href = `/login?returnUrl=${encodeURIComponent(currentUrl)}`;
      isRefreshing = false;

      return Promise.reject(normalizeApiError(error));
    }

    return Promise.reject(normalizeApiError(error));
  }
);


export default axiosInstance;
